export const theme = {
  brand: {
    name: "BluePulse",
    tagline: "Kelp intelligence across satellites, sensors, and time.",
  },
  colors: {
    kelp: "#3CFF87",
    ocean: "#06111A",
  },
};
